import { get } from "@/utils/request"; // 导入模块

// 企业详情
export const getClientDetail = (params) =>
  get("Api/ClientDetail/GetClientDetail", params);

// 企业在招职位
export const getClientJobList = (params) =>
  get("Api/ClientDetail/GetClientDetailJobList", params);

// 获取企业风采
export const getClientPhoto = (params) =>
  get("Api/ClientDetail/GetClientDetailClientPhotoList", params);

// // 企业详情
// export const getClientDetail = (params) =>
//   get("api/Api/ClientDetail/GetClientDetail", params);

// // 企业在招职位
// export const getClientJobList = (params) =>
//   get("api/Api/ClientDetail/GetClientDetailJobList", params);

// // 获取企业风采
// export const getClientPhoto = (params) =>
//   get("api/Api/ClientDetail/GetClientDetailClientPhotoList", params);

